export const convertToFeet = (height: number) => {
  const realFeet = (height * 0.3937) / 12 // тут более точное выражение, чем если просто поделить на NUMBER_CONVERTED_CM_TO_FEET(30.84)
  const feet = Math.floor(realFeet)
  const inches = Math.round((realFeet - feet) * 12)
  return `${feet}′${inches}″`
}
